import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { QuotationDetail_delete, QuotationDetail_create, QuotationDetail_update, QuotationDetail_readAll, QuotationDetail_readByQuotationId, QuotationDetail_readById, QuotationDetail_readByQuotationIdForImport, QuotationDetail_UpsertBulk } from 'src/app/GlobalVariables';
import { Observable } from 'rxjs';
import { QuotationDetailCreateRequestDTO, QuotationDetailDeleteRequestDTO, QuotationDetailDTO, QuotationDetailList, QuotationDetailReadByIdRequestDTO, QuotationDetailReadByQuotationIdForImportRequestDTO, QuotationDetailReadByQuotationIdRequestDTO, QuotationDetailUpdateRequestDTO, QuotationDetailUpsertBulkRequestDTO } from './quotation-detail.interface';

@Injectable({
  providedIn: 'root'
})
export class QuotationDetailService {

  constructor() { }

  http = inject(HttpClient)

   QuotationDetail_create(data: QuotationDetailCreateRequestDTO): Observable<QuotationDetailDTO> {
      return this.http.post<QuotationDetailDTO>(QuotationDetail_create, data);
    }
  
    QuotationDetail_update(data: QuotationDetailUpdateRequestDTO): Observable<QuotationDetailDTO>{
      return this.http.post<QuotationDetailDTO>(QuotationDetail_update, data);
    }
  
    QuotationDetail_Delete(data: QuotationDetailDeleteRequestDTO): Observable<void>{
      return this.http.post<void>(QuotationDetail_delete, data);
    }
  
    QuotationDetail_ReadById(data: QuotationDetailReadByIdRequestDTO): Observable<QuotationDetailDTO>{
      return this.http.post<QuotationDetailDTO>(QuotationDetail_readById, data);
    }
  
    QuotationDetail_ReadAll(): Observable<QuotationDetailList>{
       return this.http.get<QuotationDetailList>(QuotationDetail_readAll);
    }
  
    QuotationDetail_ReadByQuotationId(data: QuotationDetailReadByQuotationIdRequestDTO) : Observable<QuotationDetailList>{
      return this.http.post<QuotationDetailList>(QuotationDetail_readByQuotationId, data);
    }

    QuotationDetail_ReadByQuotationIdForImport(data: QuotationDetailReadByQuotationIdForImportRequestDTO): Observable<QuotationDetailList> {
      return this.http.post<QuotationDetailList>(QuotationDetail_readByQuotationIdForImport, data);
    }

    QuotationDetail_UpsertBulk(data: QuotationDetailUpsertBulkRequestDTO): Observable<QuotationDetailList> {
      return this.http.post<QuotationDetailList>(QuotationDetail_UpsertBulk, data);
    }
}